import PropTypes from "prop-types"
import { Card, CardBody, CardHeader } from "reactstrap"

import Header from "components/Common/Header"

const TitleAndInformation = ({
  onEdit,
  onClone,
  onDelete,
  isDisableEdit,
  isDisableClone,
  children,
  title,
  subtitle,
  icon,
  resource,
  buttons,
  customButtons,
  external,
}) => {
  return (
    <Card>
      <CardHeader className="bg-transparent border-bottom">
        <Header
          title={title}
          subtitle={subtitle}
          iconClass={icon}
          onEdit={onEdit}
          onDelete={onDelete}
          onClone={onClone}
          buttons={buttons}
          customButtons={customButtons}
          resource={resource}
          external={external}
          isDisableClone={isDisableClone}
          isDisableEdit={isDisableEdit}
        />
      </CardHeader>

      <CardBody>{children}</CardBody>
    </Card>
  )
}

TitleAndInformation.propTypes = {
  onEdit: PropTypes.func,
  onClone: PropTypes.func,
  onDelete: PropTypes.func,
  isDisableClone: PropTypes.bool,
  isDisableEdit: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.string,
  resource: PropTypes.string.isRequired,
  buttons: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  customButtons: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  external: PropTypes.bool,
}

TitleAndInformation.defaultProps = {
  onEdit: () => {},
  onClone: () => {},
  onDelete: () => {},
}

export default TitleAndInformation
